<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + rowData.pesmot_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Detalhes
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t4' + rowData.pesmot_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.pessoa_motorista_ger_risco.length > 0"
          >
            <span class="nav-link-in">
              Ger. Risco
              <i class="fa fa-info-circle"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t3' + rowData.pesmot_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.pessoa_motorista_ger_risco_erro.length > 0"
          >
            <span class="nav-link-in">
              Erros Ger. Risco
              <i class="fa fa-exclamation-triangle"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t2' + rowData.pesmot_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.pessoa_motorista_foto.length > 0"
          >
            <span class="nav-link-in">
              Foto do documento
              <i class="fa fa-picture-o"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t5' + rowData.pesmot_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.integracao_log.length > 0"
          >
            <span class="nav-link-in">
              Erros
              <i class="fa fa-times"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show"
          v-bind:id="'t1' + rowData.pesmot_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 10%">Código gestão de pagamento</th>
                <th style="width: 10%">Código gerenciamento de risco</th>
                <th style="width: 10%">
                  Código de pesquisa gerenciamento de risco
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.cd_gestao_pagto }}
                </td>
                <td>
                  {{ rowData.cd_gerenciamento_risco }}
                </td>
                <td>
                  {{ rowData.cdpesquisa_gerenciamento_risco }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t3' + rowData.pesmot_id + ''"
          v-if="rowData.pessoa_motorista_ger_risco_erro.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">Descrição</th>
                <th style="width: 10%">Tipo erro</th>
                <th style="width: 60%">XML</th>
                <th style="width: 10%">Data</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.pessoa_motorista_ger_risco_erro"
              >
                <td>
                  {{ item.descr }}
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="item.tp_erro.valor == 1"
                    >{{ item.tp_erro.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="item.tp_erro.valor == 2"
                    >{{ item.tp_erro.descr }}</span
                  >
                  <span
                    class="badge badge-info"
                    v-if="item.tp_erro.valor == 3"
                    >{{ item.tp_erro.descr }}</span
                  >
                </td>
                <td>
                  <span v-if="item.xml != null">
                    {{ item.xml }}
                  </span>
                </td>
                <td>
                  {{ formatDateHora(item.dt_inc) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t4' + rowData.pesmot_id + ''"
          v-if="rowData.pessoa_motorista_ger_risco.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 3%">Código motorista</th>
                <th style="width: 12%">Nome</th>
                <th style="width: 20%">Situação</th>
                <th style="width: 5%">Tipo situação</th>
                <th style="width: 5%">Data consulta</th>
                <th style="width: 5%">Data expiração</th>
                <th style="width: 4%">Senha</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.pessoa_motorista_ger_risco"
              >
                <td>
                  {{ item.cd_pfj }}
                </td>
                <td>
                  {{ item.nome }}
                </td>
                <td>
                  {{ item.situacao }}
                </td>
                <td>
                  {{ item.tp_situacao.descr }}
                </td>
                <td>
                  {{ formatDateHora(item.dt_consulta) }}
                </td>
                <td>
                  {{ formatDateHora(item.dt_expiracao) }}
                </td>
                <td>
                  {{ item.senha }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t2' + rowData.pesmot_id + ''"
          v-if="rowData.pessoa_motorista_foto.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 2%">N° da foto</th>
                <th style="width: 15%">Link</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="(item, i) in rowData.pessoa_motorista_foto"
              >
                <td>
                  {{ i + 1 }}
                </td>
                <td>
                  <a
                    @click="goLink(item.url_foto)"
                    target="_blank"
                    onMouseOver="this.style.color='#404E67'"
                    onMouseOut="this.style.color='#0097e6'"
                  >
                    <span v-if="item.nome_foto != null">
                      {{ item.nome_foto }}
                    </span>
                    <span v-if="item.nome_foto == null">
                      {{ item.url }}
                    </span>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t5' + rowData.pesmot_id + ''"
          v-if="rowData.integracao_log.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 10%">Entidade</th>
                <th data-toggle="true" style="width: 80%">Descrição</th>
                <th data-toggle="true" style="width: 10%">Data erro</th>
              </tr>
            </thead>
            <tbody v-for="item2 in rowData.integracao_log">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span
                    class="badge badge-primary"
                    v-if="item2.integracao != null"
                    >{{ item2.integracao.descr }}</span
                  >
                </td>
                <td>
                  {{ item2.descr }}
                </td>
                <td>
                  {{ formatDateHora(item2.dt_inc) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      helpForm: new Form({ statusRecord: [], params: [] }),
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;

      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY/MM/DD").format(fmt);
    },
    formatDateHora(value, fmt = "DD/MM/YYYY HH:mm") {
      return value == null ? "" : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    goLink(data) {
      window.open(data, "_blank");
    },
  },
};
</script>
